import React from 'react';
import { TenantManagementPage } from '../features/tenant-management';

const consoleMode = String(
  process.env.REACT_APP_TENANT_MANAGEMENT_MODE || process.env.REACT_APP_APP_ROLE || 'ovplan'
).toLowerCase();
const isCentralConsole = consoleMode === 'ccs' || consoleMode === 'central';

const tenantCollectionNames = isCentralConsole
  ? {
      tenants: 'tenants',
      users: 'users',
      userGroups: 'userGroups',
    }
  : undefined;

const TenantPage = (props) => (
  <TenantManagementPage
    {...props}
    consoleMode={consoleMode}
    headerTitle={isCentralConsole ? 'CCS Tenant Management' : 'Ovplan Tenant Management'}
    collectionNames={tenantCollectionNames}
  />
);

export default TenantPage;
